import { useResourceProvider } from "@/shared/useResourceProvider";
import { ref } from "@vue/composition-api";
import _ from "lodash";

import { meResource } from "@megarax/iam/restApi";

const linkActionMap = {
  "crm.myVisit": "crm.myWorkDays.retrieve",
  "crm.visit": "crm.workDays.retrieve",
  "crm.salesperson": "crm.salespeople.list",
  "crm.route": "crm.route.list",
  "crm.chain": "crm.chain.list",
  "crm.customer": "search.customers.list",
  "crm.checklistTemplate": "crm.checklistTemplate.list",

  "pricing.priceList": "pricing.priceLists.list",
  "pricing.tradeItem": "pricing.tradeItems.list",

  "sales.order": "sales.orders.list",
  "sales.myOrder": "sales.myOrders.list",
  "sales.customer": "search.customers.list",
  "sales.productionSchedule": "sales.orders.productionSchedule",

  "iam.roles": "iam.roles.list",
  "iam.users": "iam.users.list",
  "iam.groups": "iam.groups.list",

  "invoices.invoiceThreads.myThreads": "invoices.invoiceThreads.myThreads",
  "invoices.invoiceThreads.allThreads": "invoices.invoiceThreads.allThreads",
  "invoices.budgets": "invoices.budgets.list",

  "priceReport.subjects": "priceReport.subjects.all",
  "priceReport.myPriceReport": "priceReport.reports.myPastReports",

  "profitMargin.regionMargins": "profitMargin.orders.regionMargins",
  "profitMargin.targets": "profitMargin.targetTable.retrieve",
  "profitMargin.costs": "profitMargin.costTable.retrieve",
  "profitMargin.discounts": "profitMargin.discountTable.retrieve",

  "plm.komponent": "plm.komponent.list",
  "plm.receptura": "plm.receptura.list",
  "plm.produkt": "plm.produkt.list",
  "plm.productList": "plm.productList.list",
  "plm.wyrob": "plm.wyrob.list",
  "plm.asortyment": "plm.asortyment.list",
  "plm.productionRecipe": "plm.productionRecipe.list",
  "plm.brand": "plm.brand.list",
  "plm.rodzajKomponentu": "plm.rodzajKomponentu.list",
  "plm.ingredientGroup": "plm.ingredientGroup.list",
  "plm.productGroup": "plm.productGroup.list",
  "plm.obiektZastosowania": "plm.obiektZastosowania.list",
  "plm.czescBudynku": "plm.czescBudynku.list",
  "plm.narzedzie": "plm.narzedzie.list",
  "plm.rozpuszczalnik": "plm.rozpuszczalnik.list",
  "plm.rodzajOpakowania": "plm.rodzajOpakowania.list",
  "plm.podloze": "plm.podloze.list",
  "plm.jednostkaSprzedazy": "plm.jednostkaSprzedazy.list",
  "plm.language": "plm.language.list",
  "plm.opakowanie": "plm.opakowanie.list",
};

const actionsToCheck = Object.values(linkActionMap);

export const useAccessibleServices = () => {
  const meProvider = useResourceProvider(meResource);
  const accessibleServices = ref<string[] | null>(null);

  meProvider
    .isAllowedEach(undefined, actionsToCheck)
    .then((dictionary) =>
      _(dictionary)
        .entries()
        .filter(([n, isAllowed]) => isAllowed)
        .map(([name]) => _.findKey(linkActionMap, (value) => value === name) ?? "")
        .value(),
    )
    .then((names) => {
      accessibleServices.value = names;
    });

  return accessibleServices;
};
